import React from "react";
import pospWorkImage from "../../Assets/Images/PospWork.svg"
const HowItWorks = () => {
    return (
        <div style={{ backgroundColor: "#ffffff" }}>
            <div className="container py-4">
                <div
                    className="d-flex justify-content-center align-item-center "
                    style={{ color: "#1f2c6a" }}
                >
                    <h1>What is PoSP?</h1>
                </div>
                <div className="row ">
                    <div className="col-md-5 col-sm-12 pt-2 posp-work-img-div" >
                        <img src={pospWorkImage} alt="posp" className="posp-image" />
                    </div>
                    <div className="col-md-7 pt-4 col-sm-12" >
                        <p>
                            <span style={{ color: "#1f2c6a" }}>A Point of Sales Person (PoSP) </span>is a frontline representative in retail and service industries, tasked with facilitating seamless transactions and ensuring positive customer experiences. They process sales transactions accurately and efficiently, handle various payment methods, provide assistance with product inquiries, and resolve any issues that may arise during the purchase process. POSPs operate point of sales systems, maintain transaction accuracy and security, and may engage in upselling or cross-selling techniques to maximize sales opportunities. They play a pivotal role in driving revenue, maintaining customer satisfaction, and upholding operational standards at the point of sales.
                            <br />
                            <br />
                            <strong style={{ fontWeight: "500", color: "#1f2c6a", fontSize: "20px" }}>What can you sell as a PoSP?</strong>
                            <br />
                            With Buy Policy Now, you can sell Car Insurance, Bike Insurance,
                            Health Insurance, International Travel Insurance, Personal Accident
                            Cover, and SFSP Insurance.
                        </p>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default HowItWorks;
